export default () => {
  return localStorage.getItem('ImpersonatedBy') !== null;
};
